import React, { useState, useContext, useEffect } from 'react';
import UserContext from './UserContext';
import { getSessionFromDB } from '../Sessions.jsx';

const LogOnRoute = () => {
  const styles = {
    form: {
      maxWidth: '90%',
      margin: '2rem auto',
      padding: '1rem',
      backgroundColor: 'black',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
    formGroup: {
      marginBottom: '1rem',
    },
    label: {
      display: 'block',
      marginBottom: '0.5rem',
      fontWeight: 'bold',
      color: 'white',
      fontSize: '2rem',
    },
    url: {
      backgroundColor:'rgba(38, 43, 138, 1)',
      borderRadius: '4px',
      borderColor: 'rgba(55, 63, 216, 1)',
      border: '2px solid',
      marginTop: '10px',
      height: '7vh',
      width: '80vw',
      margin: '20px',
      padding: '5px',
      justifyContent: 'center',
      textAlign: 'center',
      color: 'white'
    },
    urla: {
      color: 'white'
    }

  };
  
    // RECUPERATION CONTEXTE
    const { session, setSession } = useContext(UserContext);
    const [error, setError] = useState('');

    const  getTeamCode = async () => {
      const params = new URLSearchParams(window.location.search);
      if (params.get("vi") == null) {
        return
      }
      await getSessionFromDB(params.get("vi")).then((data) => {
        console.log(data);
        if (data.error == null) {
          setSession({session, type: 'creation', value: data });}
        else
          setError(data.error);
      });
    }

    useEffect(() => {
      getTeamCode();
    }, []);

    if ( error !== '')
      return (
        <div style={styles.form}>
            <label  style={styles.label}>
              <h2>Oups !</h2>
              <p>{error}</p>
            </label>
        </div>
      );

    if (session.step == -1)
      return (
        <>
          <div className="hero-content">
              <div className="col"></div>
              <div className="col logo"></div>
              <div className="col"></div>
          </div>
          <div style={styles.form}>
              <label style={styles.label}>
                <h3>Où vous trouvez-vous ?</h3>
                <p style={styles.url}><a style={styles.urla} href="/?vi=vp" target="_self">Marseille (parcours Vieux-Port)</a></p>
                <p style={styles.url}><a style={styles.urla} href="/?vi=panier" target="_self">Marseille (parcours Panier)</a></p>
                <p style={styles.url}><a style={styles.urla} href="/?vi=aix2" target="_self">Aix-en-Provence</a></p>
                <p style={styles.url}><a style={styles.urla} href="/?vi=avi" target="_self">Avignon</a></p>
                <p style={styles.url}><a style={styles.urla} href="/?vi=arl" target="_self">Arles</a></p>
                <p style={styles.url}><a style={styles.urla} href="/?vi=sif" target="_self">Six-Fours-les-Plages</a></p>
                <p style={styles.url}><a style={styles.urla} href="/?vi=sal" target="_self">Salon-de-Provence</a></p>
                <p style={styles.url}><a style={styles.urla} href="/?vi=nimes" target="_self">Nîmes</a></p>
                <p style={styles.url}><a style={styles.urla} href="/?vi=cry" target="_self">Carry</a></p>
              </label>
          </div>
        </>
      );
};


export default LogOnRoute;